(function(){
        function sanitizeText(str){
          if(!str) return str;
          var s = str;
          // Clean 1" at start or after bullets / whitespace: e.g. 1"Na stanju", · 1"Versand...
          s = s.replace(/(^|[\s·•\-])1["']([A-Za-zČĆŽŠĐčćžšđ0-9])/g, '$1$2');
          // Clean 1 directly before words: e.g. 1Povratak, 1Sigurnost
          s = s.replace(/(^|[\s·•\-])1([A-ZČĆŽŠĐ][a-zčćžšđ])/g, '$1$2');
          // Clean standalone leading 1" or 1'
          s = s.replace(/^1["'\s]+/, '');
          // Remove trailing quotes introduced by the malformed prefix
          if(/^["']/.test(str) === false && /"$/.test(s) && (s.match(/"/g) || []).length % 2 !== 0){
            s = s.replace(/"$/, '');
          }
          return s;
        }
        function sanitizeNode(n){
          if(!n) return;
          if(n.nodeType === 3 && n.nodeValue){
            var orig = n.nodeValue;
            var cleaned = sanitizeText(orig);
            if(cleaned !== orig) n.nodeValue = cleaned;
          } else if(n.nodeType === 1){
            if(n.tagName === 'SCRIPT' || n.tagName === 'STYLE' || n.tagName === 'NOSCRIPT') return;
            for(var i=0; i<n.childNodes.length; i++){
              sanitizeNode(n.childNodes[i]);
            }
          }
        }
        function run(){
          if(document.body) sanitizeNode(document.body);
        }
        if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
        else run();
        setTimeout(run, 300);
        setTimeout(run, 1000);
        setTimeout(run, 2500);
        if(window.MutationObserver){
          var mo = new MutationObserver(function(muts){
            for(var i=0; i<muts.length; i++){
              var m = muts[i];
              if(m.type === 'childList'){
                for(var j=0; j<m.addedNodes.length; j++){
                  sanitizeNode(m.addedNodes[j]);
                }
              } else if(m.type === 'characterData'){
                sanitizeNode(m.target);
              }
            }
          });
          if(document.body) mo.observe(document.body, { childList: true, subtree: true, characterData: true });
        }
      })();
